import _ from 'lodash';
import React, { useContext, useState, useEffect } from 'react';

import { Row, Col} from 'react-bootstrap';
import Utils from '../Utils';

import UserContext from './../contexts/UserContext';
const MainHeader = (props) => {
  
  const {logout} = useContext(UserContext);
  const usernm = Utils.getUserData();

  const [isActive, setActive] = useState(false);

  const toggleClass = () => {
    setActive(!isActive);
  };

  return <Row>
    <Col className="logotxt text-left pt-2 pb-2 logoheader pl-4 ml-5">
      <a href='/'><img src={`${process.env.PUBLIC_URL}/images/logo-blk.png`} alt="" className="img-fluid logo bg-mycolor" /></a>

      {Utils.isLoggedIn() && <>
        <nav className="topNav">
          <ul>

            {/* <li onClick={() => {window.location.href=`${process.env.PUBLIC_URL}/password`;}}>
          <span className="txt">{usernm.username}</span>
          <span className="icon key"></span>
        </li> */}
            <li><div id="google_translate_element" className='g-trans'></div></li>
            <li onClick={() => {window.location.href = `${process.env.PUBLIC_URL}/password`;}}>
              <span className="txt">Change Password</span>
              <span className="icon key"></span>
            </li>
            <li onClick={() => {window.location.href = `${process.env.PUBLIC_URL}/builder`;}}>
              <span className="txt">Build your SCORM</span>
              <span className="icon list-ul"></span>
            </li>
            <li onClick={() => {window.location.href = `${process.env.PUBLIC_URL}/myorders`;}}>
              <span className="txt">My Orders</span>
              <span className="icon shopping-cart"></span>
            </li>
            <li onClick={() => {window.location.href = `${process.env.PUBLIC_URL}/scorms`;}}>
              <span className="txt">My Authoring Log</span>
              <span className="icon book"></span>
            </li>
            {/* <li onClick={() => logout(()=>{window.location.reload();})}>
          <span className="txt">Log-out</span>
          <span className="icon sign-out"></span>
        </li> */}
            <li onClick={toggleClass} id="unm" className={isActive ? 'user active' : 'user'} >
              <span className="icon"></span>
              <div className="user-name"><span className="useWelcome">Welcome</span><br />{_.compact([usernm.fname, usernm.lname]).join(' ')}!</div>
              <div className="ddac">
                <span className="logout" onClick={() => logout(() => { window.location.reload();})}>Logout</span>
              </div>
            </li>

          </ul>
        </nav>
      </>}
       
       
    </Col>
  </Row>;
}

export default MainHeader;